import React from 'react';
import { Grid } from '@material-ui/core';
import type { Theme } from '@material-ui/core';

import { useKlpStyles } from '@klp/design/Theme';
import { Typography } from '@klp/design/Typography';

export interface IKeyValueProps {
    title: string;
    disableTypography?: boolean;
    children?: React.ReactNode;
    'data-testid'?: string;
}

const styles = (theme: Theme) => ({
    divider: {
        borderBottom: '1px solid transparent',
        borderBottomColor: theme.palette.primary.medium,
    },
    title: {
        wordBreak: 'break-all',
    },
});

export const KeyValueItem: React.FC<IKeyValueProps> = ({
    title,
    disableTypography,
    children,
    ...rest
}) => {
    const classes = useKlpStyles({}, styles);

    return (
        <Grid item={true} xs={12} md={6} data-testid={rest['data-testid']}>
            <Grid container={true} className={classes.divider}>
                <Grid item={true} xs={true}>
                    <Typography
                        translation={title}
                        className={classes.title}
                        klpTypographyVariant="small"
                        paddingVertical="tiny"
                    />
                </Grid>
                <Grid item={true} xs={true}>
                    {disableTypography ? (
                        children
                    ) : (
                        <Typography
                            klpTypographyVariant="small"
                            paddingVertical="tiny"
                        >
                            {children}
                        </Typography>
                    )}
                </Grid>
            </Grid>
        </Grid>
    );
};

KeyValueItem.displayName = 'KeyValueItem';
